const clearSchemaFields = [
  "linkingIsNetwork",
  "linkingAcknowledgedDate",
  "linkingAcknowledgedBy",
  "pwdLinking",
  "_blsCounties",
  "_9141_meta_case_status",
  "_9141_f4_prevailing_wage",
  "_9141_f5_wage_per",
  "pwdDateSubmitted",
  "pwdDeterminationDate",
  "tempneedJobtitle",
  "tempneedSoc",
  "tempneedSocTitle",
  "empBusinessName",
  "empTradeName",
  "empAddr1",
  "empAddr2",
  "empCity",
  "empState",
  "empPostcode",
  "empCountry",
  "empProvince",
  "empPhone",
  "empPhoneext",
  "empFein",
  "empNaics",
  "empNaicsDescription",
  "emppocLastname",
  "emppocFirstname",
  "emppocMiddlename",
  "emppocJobtitle",
  "emppocAddr1",
  "emppocAddr2",
  "emppocCity",
  "emppocState",
  "emppocPostcode",
  "emppocCountry",
  "emppocProvince",
  "emppocPhone",
  "emppocPhoneext",
  "emppocEmail",
  "attyRepresentType",
  "attyLastname",
  "attyFirstname",
  "attyMiddlename",
  "attyAddr1",
  "attyAddr2",
  "attyCity",
  "attyState",
  "attyPostcode",
  "attyCountry",
  "attyProvince",
  "attyPhone",
  "attyPhoneext",
  "attyEmail",
  "attyBizname",
  "attyFein",
  "attyStatebarno",
  "attyStatehighct",
  "attyNamehighct",
  "jobDuties",
  "jobMinedu",
  "jobMintrainingmonths",
  "jobMinexpmonths",
  "jobSupervisor",
  "jobNumberSup",
  "jobMinspecialreq",
  "jobAddr1",
  "jobAddr2",
  "jobCity",
  "jobState",
  "jobPostcode",
  "jobCounty",
  "jobMsa",
  "wagePer",
  "jobPwdNumber1",
  "jobPwdNumber2",
  "jobPwdNumber3",
  "jobMultiplesites",
  "employmentLocationWorksites",
  "registrationNumber",
  "isRegistrationNumberLinked",
];
const clearFileFields = [
  "emergencyJustification",
  "attyIsAgreementAttached",
  "agntMspaAttached",
  "e21a_is_mspa_uploaded",
  //not updated
];
export default {
  name: "Preliminary Questions",
  pageInfo: {
    text: `Employers seeking H-2B workers must file a completed Application for Temporary Employment Certification 
    (ETA Form 9142B and the appropriate appendices and valid PWD), a copy of the job order being submitted 
    concurrently to the SWA serving the area of intended employment, and copies of all contracts and agreements 
    with any agent and/or recruiter, executed in connection with the job opportunities.
    <br/>
    <br/>
    Employers seeking a waiver of the time period for filing due to an emergency situation must submit a request 
    for a waiver of the time period requirement, a completed Application for Temporary Employment Certification 
    and the proposed job order identifying the SWA serving the area of intended employment, and must otherwise 
    meet the filing requirements above.`,
    coloring: "grey",
  },
  sections: [
    {
      name: "Emergency Filing and your Prevailing Wage",
      fields: [
        {
          machine_name: "_blsCounties",
          widget: "text",
          hidden: true,
        },
        {
          isGroup: {
            code: "F.b.11",
            machine_name: "isEmergency",
            label:
              "Are you requesting a waiver of the period for filing this application (i.e., 90 to 75 days before the expected start date of work) due to an emergency situation under 20 CFR 655.17? *",
            tooltip: `If the employer is requesting emergency situation processing for this application under 20 CFR 655.17 and has not yet
              received a PWD, indicate whether the employer has attached to its Application a completed Application for Prevailing Wage
              Determination (Form ETA-9141) by indicating "Yes" or "No." Mark the option "N/A" if the employer has not requested an
              emergency waiver filing timeframe.`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
                clearSchema: clearSchemaFields, // need to clear out PW UI label as well
                clearTableErrors: ["employmentLocations"],
                clearFiles: clearFileFields,
                setSchema: [
                  {
                    set: "employmentLocations",
                    to: [],
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: clearSchemaFields, // need to clear out PW UI label as well
                clearTableErrors: ["employmentLocations"],
                setSchema: [
                  {
                    set: "employmentLocations",
                    to: [],
                  },
                ],
                clearFiles: clearFileFields,
              },
            ],
          },
        },
        {
          machine_name: "emergencyJustification",
          name: "Emergency Filing Justification",
          code: "F.b.11",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          isVisible: {
            when: "isEmergency",
            is: "YES",
          },
          widget: "file_upload",
          label: `A statement justifying the employer's emergency situation is attached to this application.`,
          validate: ["required", "checkValue"],
        },
      ],
    },
    {
      coloring: "blue",
      isVisible: {
        when: "isEmergency",
        is: [undefined],
        operator: "!==",
      },
      fields: [
        {
          code: "F.b.10/F.b.10a/F.b.10b",
          machine_name: "pwdLinking",
          widget: "pw_lookup",
          label:
            "Locate your Form ETA-9141, Application for Prevailing Wage Determination (PWD) below. *",
          validate: [
            {
              requiredWithCustomMessage:
                "You must link a prevailing wage determination to this case.",
            },
            "pNumberCheck",
          ],
          tooltip:
            "Select one to three 14-digit PWD numbers assigned by the National Prevailing Wage Center for the job opportunity listed on the application.",
          info: "If you do not have a relevant Form ETA-9141, Application for Prevailing Wage Determination, please complete one and return to this form once you have submitted.",
          pw_lookup: {
            formType: {
              this: "9141",
              to: "9142B",
            },
            PWFields: {
              PWLinkingFields: [
                "jobPwdNumber1",
                "jobPwdNumber2",
                "jobPwdNumber3",
              ],
              extraFieldsToSetPrimaryPW: ["pwdLinking"], // populate primary pw elsewhere
            },
            worksiteFields: {
              importedWorksites: "employmentLocations",
              chosenWorksites: "employmentLocationWorksites",
              bls_counties: "_blsCounties",
            },
            emergencyField: "isEmergency",
            // icertView: true,
            buttonPrimary: "PWD Case Lookup",
            socField: "tempneedSoc",
            feinField: "empFein",
          },
        },
      ],
    },
  ],
};
